'use es6';

import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import getEarlyRequesterResultPromise from 'ContentEditorUI/earlyRequester/getEarlyRequesterResultPromise';
const fetch = () => {
  return getEarlyRequesterResultPromise('initial-blog-posts-limit-fetch', false) || http.get(`blogs/v3/blog-posts/${PortalIdParser.get()}/usage`);
};
const fetchMlangLimit = contentId => {
  return http.get(`blogs/v3/blog-posts/${contentId}/multilang-usage`);
};
export default {
  fetch,
  fetchMlangLimit
};